import {
  MY_RFI_API_ORDER_BY_FIELD,
  mapMyRfiItemToGridRow,
  mapGridRowToExportRecord,
  sortConfigToApiSortParamsWithFieldMap,
  sortMyRfiItems,
  filterMyRfiItemsByClientFilters,
} from "../../../utils/myRfiGridRowMapper";
import { getGridArchiveCommentDisplay } from "../../../utils/gridArchiveCommentDisplay";

/**
 * Toggle server-side sort for Admin get_rfis vs client-side sort on the current page.
 */
export const BACKEND_RFIS_USE_SERVER_SORT = true;

/**
 * Admin get_rfis: `order_by` field names (must match backend contract).
 * Includes sponsor; other keys align with user RFI grid where applicable.
 */
export const BACKEND_RFI_API_ORDER_BY_FIELD = {
  sponsor: "sponsor_name",
  ...MY_RFI_API_ORDER_BY_FIELD,
};

export function sortBackendRfiConfigToApiSortParams(sortConfig) {
  return sortConfigToApiSortParamsWithFieldMap(
    BACKEND_RFI_API_ORDER_BY_FIELD,
    sortConfig
  );
}

export function sortBackendRfiItems(items, sortConfig) {
  return sortMyRfiItems(items, sortConfig);
}

export { filterMyRfiItemsByClientFilters };

export const BACKEND_RFI_EXPORT_HEADERS = [
  "Sponsor",
  "Vendor",
  "Type",
  "GxP",
  "Template",
  "Location",
  "Risk Summary",
  "Status",
  "Request Date",
  "Due Date",
  "Release Date",
  "Completion Date",
  "Cycle Time",
  "Archive Comment",
];

export function mapBackendRfiItemToExportRecord(item) {
  const row = mapMyRfiItemToGridRow(item);
  const base = mapGridRowToExportRecord(row);
  return {
    Sponsor: item?.sponsorName ?? "",
    ...base,
    "Archive Comment": getGridArchiveCommentDisplay(item) || "",
  };
}
